import { render, staticRenderFns, recyclableRender, components } from "./comb.vue?vue&type=template&id=1ef9293c&"
var renderjs
import script from "./comb.vue?vue&type=script&lang=js&"
export * from "./comb.vue?vue&type=script&lang=js&"
import style0 from "./comb.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!C:\\Users\\dell\\Downloads\\HBuilderX.3.2.16.20211122.full\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\@dcloudio\\vue-cli-plugin-uni\\packages\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/basics/comb.vue"
export default component.exports